function fallbackCopyTextToClipboard(text: string): boolean {
    var textArea = document.createElement("textarea");
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        let successful = document.execCommand('copy');
        let msg = successful ? 'successful' : 'unsuccessful';
        console.log('Fallback: Copying text command was ' + msg);
        return true
    } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
        return false;
    } finally {
        document.body.removeChild(textArea);
    }
}
export function copyTextToClipboard(text: string, callback: (success: boolean) => void) {
    if (!navigator.clipboard) {
        callback(fallbackCopyTextToClipboard(text));
        return;
    }
    navigator.clipboard.writeText(text).then(function() {
        console.log('Async: Copying to clipboard was successful!');
        callback(true)
    }, function(err) {
        console.error('Async: Could not copy text: ', err);
        callback(false)
    });
}